export const NewAccountReviewContent = {
  pageIDHeader: 'Account ',
  pageTitle: 'Please review your application to open an account',
  progressButtons: {
    transfer: 'Transfer another account',
    review: 'Review and sign',
  },
  banner: {
    header: 'Important information about your new account',
    content:
      'Your new account won’t officially be opened until you finish this entire process and submit the information for <em>all</em> of your accounts.',
  },
};
